import {
    Card,
    CardContent,
    Chip,
    makeStyles
} from "@material-ui/core";
import { ChevronRight } from "@material-ui/icons";
import clsx from "clsx";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const useStyles = makeStyles({
  root: {
    maxWidth: "100%",
    borderRadius: 17,
    padding: "20px 24px",
    border: "1px solid #CCCCCC",
    boxShadow: "none",
    backgroundColor: "#FFFFFF",
    minHeight: "64px",
    cursor: "pointer",
  },
  cardContent: {
    padding: "0px !important",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  dashboardCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "100%",
    marginLeft: "18px",
  },
  iconWrapper: {
    minHeight: "max-content",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  dashboardCardIconWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#28a382",
    borderRadius: "50%",
    width: "48px",
    height: "48px",
  },
  dashboardCardIcon: {
    width: "24px",
    padding: "12px",
  },
  title: {
    fontSize: "16px",
    fontWeight: 500,
    letterSpacing: "-0.4px",
    margin: 0,
    padding: 0,
    textAlign: "left",
    marginBottom: "8px",
  },
  description: {
    fontSize: "12px",
    fontWeight: 400,
    letterSpacing: "-0.4px",
    margin: 0,
    padding: 0,
    textAlign: "left",
    color: "#707070",
  },
  enabledIcon: {
    height: "20px",
    width: "20px",
    marginLeft: "14px",
  },
  chevronIcon: {
    marginLeft: "14px"
  },
  badges: {
    display: "flex",
    alignItems: "center",
    fontFamily: "lexend, sans-serif",
    marginBottom: "8px",
  },
  chip: {
    fontSize: "10px",
    fontFamily: "lexend, sans-serif",
    fontWeight: 400,
    letterSpacing: "-0.2px",
    height: "18px",
    padding: "0",
  },
  beta: {
    color: "#059669",
    backgroundColor: "#d3f9e6",
    borderColor: "#aaf5d3",
    marginLeft: "8px",
  },
  concierge: {
    color: "#A550BB",
    borderColor: "#E3B3EE",
    backgroundColor: "#F4E3F8",
  },
  transaction: {
    color: "#EA6936",
    borderColor: "#FFBBA4",
    backgroundColor: "#FFE6DA",
  },
  admin: {
    color: "#2563EB",
    borderColor: "#BFDBFE",
    backgroundColor: "#DBEAFE",
  },
});

const DashboardCard = ({
  icon,
  iconAlt,
  title,
  description,
  link,
  beta,
  agentType,
}) => {
  const classes = useStyles();
  const history = useHistory();

  const handleClick = () => {
    if (link) {
      history.push(link);
    }
  };

  return (
    <Card className={classes.root} onClick={handleClick}>
      <CardContent className={classes.cardContent}>
        <div className={classes.iconWrapper}>
          <div className={classes.dashboardCardIconWrapper}>
            <img
              className={classes.dashboardCardIcon}
              src={icon}
              alt={iconAlt}
            />
          </div>
        </div>

        <div className={classes.dashboardCard}>
          <div className={classes.badges}>
            {agentType === "Concierge" && (
              <Chip
                className={clsx(classes.chip, classes.concierge)}
                label={agentType}
                variant="outlined"
              />
            )}
            {agentType === "Transaction" && (
              <Chip
                className={clsx(classes.chip, classes.transaction)}
                label={agentType}
                variant="outlined"
              />
            )}
            {agentType === "Admin" && (
              <Chip
                className={clsx(classes.chip, classes.admin)}
                label={agentType}
                variant="outlined"
              />
            )}

            {beta && (
              <Chip
                className={clsx(classes.chip, classes.beta)}
                label="Beta"
                variant="outlined"
              />
            )}
          </div>
          <p className={classes.title}>{title}</p>
          <p className={classes.description}>{description}</p>
        </div>
        <div className={classes.chevronIcon}>
          <ChevronRight color="#000" />
        </div>
      </CardContent>
    </Card>
  );
};

export default DashboardCard;
